import { Box } from "@mui/material";
import React from "react";
import { useMediaQuery } from "@mui/material";
import CustomSelectDropdown from "../../../../../components/CustomSelectDropDown";
import GlobalSearch from "../../../../../components/Search";
import PrimaryButton from "../../../../../components/Button/Button";
import { useCustomParams } from "../../../../../hooks/useCustomParams";

const NotRetainedFilter = ({ statusCounts }) => {
  const isMobile = useMediaQuery("(max-width:690px)");
  const [status, updateStatus] = useCustomParams("status");
  const filterButtons = [
    { label: "Total", value: "total", total: statusCounts?.total || 0 },
  ];

  const dropdownOptions = filterButtons.map((btn) => ({
    label: `${btn.label} ${btn.total}`,
    value: btn.value,
  }));
  return (
    <Box className="hpd-violations-filters bg-white">
      <Box className="filter-buttons">
        {isMobile ? (
          <CustomSelectDropdown
            options={dropdownOptions}
            label="Filter by Status"
            onSelectChange={(value) => updateStatus("status", value)}
            defaultValue={status}
          />
        ) : (
          filterButtons.map((btn, idx) => (
            <PrimaryButton
              variant="contained"
              key={idx}
              className={`capitalize violation-filter-btn ${
                btn.value === status ? "btn-bg-grey" : "btn-bg-light-grey"
              }`}
              onClick={() => updateStatus("status", btn.value)}
            >
              {btn.label}{" "}
              <span
                className={`${
                  btn.value === status ? "survey-count-select" : "survey-count"
                }`}
              >{` ${btn.total}`}</span>
            </PrimaryButton>
          ))
        )}
      </Box>
      <GlobalSearch name="not-retained-search" />
    </Box>
  );
};

export default NotRetainedFilter;